export default __webpack_public_path__ + "static/media/button-send-email.2500a576.svg";